import React, { useEffect } from 'react';
import { ArrowLeft, Clock, MapPin, GraduationCap } from 'lucide-react';
import styles from './CounselorProfileModal.module.css';

const CounselorProfileModal = ({ counselor, onClose }) => {
  // Handle ESC key to close modal
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent}>
        <button className={styles.backButton} onClick={onClose}>
          <ArrowLeft size={20} />
        </button>
        <div className={styles.modalBody}>
          <div className={styles.profileImageContainer}>
            <div className={styles.profileImagePlaceholder}></div>
          </div>
          <h2 className={styles.name}>{counselor.name}</h2>
          <p className={styles.title}>{counselor.title}</p>
          <div className={styles.education}>
            <GraduationCap size={16} className={styles.icon} />
            <span>{counselor.education}</span>
          </div>
          <div className={styles.experience}>
            <Clock size={16} className={styles.icon} />
            <span>{counselor.experience}</span>
          </div>
          <div className={styles.specialties}>
            {counselor.specialties.map((specialty, index) => (
              <span
                key={index}
                className={`${styles.specialtyTag} ${
                  specialty === "All Specialties" ? styles.specialtyTagActive : ''
                }`}
              >
                {specialty}
              </span>
            ))}
          </div>
          <div className={styles.locationPriceRow}>
            <div className={styles.location}>
              <MapPin size={16} className={styles.icon} />
              <span>{counselor.location}</span>
            </div>
            <div className={styles.price}>
              ${counselor.hourlyRate}/hour
            </div>
          </div>
          <button className={styles.bookButton}>
            Book Appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounselorProfileModal;

